import React from 'react';
import { Input, Adornment, Button, AdornedInput } from '@zillow/constellation';

export const PLACEHOLDER_TEXT = 'Enter your home address';

interface ComboboxOption {
    id?: number | string;
    value: string;
    label: string;
}

interface SearchInputWithButtonProps {
    handleAddressSelect: ({ zpid: string, placementId, surfaceId }) => void;
    placementId: string;
    surfaceId: string;
    onTagClose?: () => void;
    onClear?: () => void;
    options: ComboboxOption[];
}

const SearchInputWithButton: React.FC<SearchInputWithButtonProps> = ({
    handleAddressSelect,
    placementId,
    surfaceId,
    onTagClose,
    onClear,
    options,
    ...props
}) => (
    <AdornedInput
        input={
            <Input
                // id={undefined} prevents chrome autocomplete display
                id={undefined}
                data-testid="address-search-input"
                placeholder={PLACEHOLDER_TEXT}
                {...props}
            />
        }
        rightAdornment={
            <Adornment aria-hidden="false">
                <Button
                    name="submit-button"
                    type="submit"
                    size="sm"
                    buttonType="primary"
                    style={{
                        paddingLeft: '20px',
                        paddingRight: '20px',
                    }}
                    onClick={() =>
                        handleAddressSelect({ zpid: options[0]?.id, placementId, surfaceId })
                    }
                >
                    Get started
                </Button>
            </Adornment>
        }
    />
);

export default SearchInputWithButton;
